import { call, put, takeEvery } from "redux-saga/effects";
import { sagaTypes } from "./types";
import { IData, IDataPage } from "../../interfaces/common";
import { IAction } from "../utils";
import { getServiceOrder, getServiceOrders } from "../../api/serviceOrder";
import {
  getMoreServiceOrdersAction,
  getServiceOrderAction,
  getServiceOrdersAction,
  setSizePageAction,
} from "./action";
import { IServiceOrder } from "../../interfaces/serviceOrder";

export function* getServiceOrdersWorkerSaga({ payload }: IAction<string>) {
  const res: IDataPage<IServiceOrder[]> = yield call(getServiceOrders, payload as string);
  yield put(getServiceOrdersAction(res?.data?.items || []));
  if (res?.data) {
    const { pageSize, totalPages, totalCount, pageIndex } = res?.data;
    yield put(
      setSizePageAction({ pageSize, totalPages, totalCount, pageIndex })
    );
  }
}

export function* getMoreServiceOrdersWorkerSaga({ payload }: IAction<string>) {
  const res: IDataPage<IServiceOrder[]> = yield call(getServiceOrders, payload as string);
  yield put(getMoreServiceOrdersAction(res?.data?.items || []));
  if (res?.data) {
    const { pageSize, totalPages, totalCount, pageIndex } = res?.data;
    yield put(
      setSizePageAction({ pageSize, totalPages, totalCount, pageIndex })
    );
  }
}

export function* getServiceOrderWorkerSaga({ payload }: IAction<string>) {
  const res: IData<IServiceOrder> = yield call(getServiceOrder, payload as string);
  yield put(getServiceOrderAction(res?.data));
}

export function* serviceOrdersWatcherSaga() {
  yield takeEvery(sagaTypes?.GET_ALL_SERVICEORDERS, getServiceOrdersWorkerSaga);
  yield takeEvery(sagaTypes?.GET_MORE_SERVICEORDERS, getMoreServiceOrdersWorkerSaga);
  yield takeEvery(sagaTypes?.GET_SERVICEORDER, getServiceOrderWorkerSaga);
}
